export const dxRegisterTypeEnum = {
    ADV_EU: 'ADV_EU',
};
